import React from 'react';
import { connect } from 'react-redux';
import FlexView, { FlexViewMain } from '../../views/flexView/FlexView';
import OptionTabs from './OptionTabs';
import StepHeader from '../../components/stepHeader/StepHeader';
import { OPTIONS } from '../../common/steps';
import Categories from './Categories';

const Options = ({ options, breakpoint, bottomOffset }) => {
  const { tabs, categories } = options;
  const showTabs = tabs.length > 0;

  const ANALYTICS_KEY = 'options';

  return (
    <FlexView bottomOffset={bottomOffset}>
      <FlexViewMain>
        <StepHeader step={OPTIONS} />
        {showTabs ? (
          <OptionTabs
            tabs={tabs}
            breakpoint={breakpoint}
            analyticsKey={ANALYTICS_KEY}
          />
        ) : (
          <Categories categories={categories} />
        )}
      </FlexViewMain>
    </FlexView>
  );
};

const mapStateToProps = (state) => {
  const { exteriorInteriorOptions: options } = state.config;
  const { breakpoint } = state;
  return {
    breakpoint,
    options,
  };
};

export default connect(mapStateToProps)(Options);
